import React from "react";
import { Modal, Typography } from "@ann/web-components";

const DeleteDocumentModal = ({
  size = "medium",
  modalWidth = "571px",
  isOpen,
  onClose,
  onConfirm,
  documentName = "",
  isDeleting = false,
  disabled = false,
}) => {
  const handleConfirm = () => {
    if (onConfirm && !isDeleting) {
      onConfirm();
    }
  };

  const handleClose = () => {
    if (!isDeleting && onClose) {
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width={modalWidth} size={size}>
      <Modal.Header icon>
        <Modal.Header.Icon name="info" variant="alert" />
        <Modal.Header.Title>
          Are you sure you want to delete {documentName}?
        </Modal.Header.Title>
      </Modal.Header>

      <Modal.Actions align="center">
        <Modal.Button
          label="Cancel"
          type="secondary"
          onClick={handleClose}
          disabled={isDeleting}
        />
        <Modal.Button
          label={isDeleting ? "Deleting..." : "Delete"}
          onClick={handleConfirm}
          disabled={disabled || isDeleting}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteDocumentModal;
